/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { useIntl } from 'react-intl'
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers'
import moment from 'moment'

type Props = {
    className: string,
    parentToChild?: any[]
}

const AccountsTable: React.FC<Props> = ({ parentToChild, className }) => {
    const intl = useIntl();
    return (
        <div className={`card ${className}`} style={{ width: "100%", position: "relative", backgroundColor: "InfoBackground", alignSelf: "center" }}>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                    <span className='text-muted mt-1 fw-bold fs-7'>{intl.formatMessage({ id: 'ACCOUNT.RECENTRESULTS' })}</span>
                </h3>
            </div>
            {/* end::Header */}
            {/* begin::Body */}
            <div className='card-body py-3'>
                {/* begin::Table container */}
                <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                        {/* begin::Table head */}
                        <thead>
                            <tr className='fw-bolder text-muted'>
                                <th></th>
                                <th>Ažuriran</th>
                                <th>Bban</th>
                                <th>Iban</th>
                                <th>Pravno lice</th>
                                <th className="text-center">Vrsta</th>
                                <th className="text-center">Status</th>
                                {/*  <th>Details</th>*/}
                            </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                            {parentToChild!.map(o => <tr key={o.accountId}>
                                <td width="3%">
                                    <img width="40px" height="40px" src={toAbsoluteUrl('/media/logoBanks/' + o.bankCode + '.png')} alt='imgBank' />
                                </td>
                                <td width="15%">
                                    <a href='#' title="Datum i vrijeme posljednje izmjene statusa računa" className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                                        {moment(o.statusDateTime).format("DD.MM.YYYY. HH:mm:ss")}
                                    </a>
                                    <span title="Datum i vrijeme posljednje izmjene vrste računa" className='text-muted fw-bold text-muted d-block fs-7'>
                                        {moment(o.typeDateTime).format("DD.MM.YYYY. HH:mm:ss")}
                                    </span>
                                </td>
                                <td>
                                    <a href='#' className='text-dark fw-bolder text-hover-primary fs-6'>
                                        {o.bban}
                                    </a>
                                    <span className='text-muted fw-bold text-muted d-block fs-7'>
                                        {o.bank}
                                    </span>
                                </td>
                                <td>
                                    <a href='#' className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                                        {o.iban}
                                    </a>
                                    <span className='text-muted fw-bold text-muted d-block fs-7'> {o.bic}</span>
                                </td>
                                <td width="30%" title={o.businessEntityLocation}>
                                    <a href='#' className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                                        {o.businessEntityId}
                                    </a>
                                    <span className='text-muted fw-bold text-muted d-block fs-7'> {o.businessEntityName} </span>
                                </td>
                                <td className="text-center">
                                    <a href='#' className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                                        {((o.type ?? '').trim() != 'X' && (o.type ?? '').trim() != '' && (o.type ?? '').trim() != null) ? o.type : 'Vrsta računa nije određena'}
                                    </a>
                                </td>
                                <td className="text-center">
                                    {(o.status != null ? o.status.trim() : o.status) == "A" ? <span className='badge badge-light-success' title="Aktivan račun">{o.status}</span>
                                        : (o.status != null ? o.status.trim() : o.status) == "B" ? <span className='badge badge-light-danger' title="Blokiran račun">{o.status}</span>
                                            : <span className='badge badge-light-warning' title="Ugašen račun">{o.status}</span>}
                                </td>
                                {/*<td>*/}
                                {/*    <KTSVG path='/media/icons/duotune/general/gen019.svg' className='svg-icon-3' />*/}
                                {/*    <a href="#" className="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">*/}
                                {/*        Actions*/}
                                {/*        <span className="svg-icon svg-icon-5 m-0">*/}
                                {/*            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">*/}
                                {/*                <path d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z" fill="black"></path>*/}
                                {/*            </svg>*/}
                                {/*        </span>*/}
                                {/*    </a>*/}

                                {/*    <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-4" data-kt-menu="true">*/}
                                {/*        <div className="menu-item px-3">*/}
                                {/*            <a href="#" className="menu-link px-3">Potvrda solventnosti</a>*/}
                                {/*        </div>*/}
                                {/*        <div className="menu-item px-3">*/}
                                {/*            <a href="#" className="menu-link px-3">Potvrda o glavnom računu</a>*/}
                                {/*        </div>*/}
                                {/*        <div className="menu-item px-3">*/}
                                {/*            <a href="#" className="menu-link px-3">Potvrda o svim računima</a>*/}
                                {/*        </div>*/}
                                {/*    </div>*/}
                                {/*</td>*/}
                            </tr>)}
                        </tbody>
                        {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                </div>
                {/* end::Table container */}
            </div>
            {/* begin::Body */}
        </div>
    )
}




export { AccountsTable }
